/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import translate from '../../../../classes/lang.js'
import * as Jsx from './poll_item.jsx'
const { rxaget } = global.rootRequire('classes/ulti')
const { getAttachments } = global.rootRequire('classes/chat')
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const chatDB = global.rootRequire('classes/indexedDB').default

class RxPollItem_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      currentMsg: rxaget(this.props, 'currentMsg', {}),
      pollInfo:{},
      user_created:{},
      group_id:rxaget(this.props, 'rxgroup.group.group_id', ''),
    }
    this.flagFetchPoll = false
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
  }
  componentDidMount() {
    this.flagFetchPoll = false
    this.fetchPoll()
  }

  getPollItem(poll_id,polls){
    let pollsArr = polls.data
    let poll_item = pollsArr.find(o => o.poll_id === poll_id);
    // poll_item.currentMsg = this.state.currentMsg
    return poll_item
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(this.props.rxChangePolls.status !==  nextProps.rxChangePolls.status){
      let pollInfo = this.state.pollInfo
      let group_id = this.state.group_id
      chatDB.polls.get(group_id.toString()).then(polls=>{
        let pollItem = this.getPollItem(pollInfo.poll_id,polls)
        if(pollItem){
          this.setState({pollInfo:pollItem})
        }
      })
    }

  }

  async fetchPoll(){
    if (this.props.comp === 'poll_list_item') {
      let pollInfo = this.props.pollInfo
      this.setState({pollInfo:pollInfo})
    }else{
      let group_id = this.state.group_id
      let currentMsg = this.state.currentMsg
      // let attachments = JSON.parse(rxaget(currentMsg, 'attachments', '').replace(/\\/g, '\\\\'))
      let attachments = getAttachments(currentMsg)
      let isExist = false
      if(attachments && attachments.poll_id){
        let polls = await chatDB.polls.get(group_id.toString())
        if(polls && polls.data){
          this.flagFetchPoll = true
          for (let i = 0; i < polls.data.length; i++) {
            const pollItem = polls.data[i]
            if(pollItem.poll_id === attachments.poll_id){
              isExist = true
              this.setState({pollInfo:pollItem})
            }
            
          }
          if(!isExist){
            this.setState({pollInfo:attachments})
          }
        }else{
          this.setState({pollInfo:attachments})
          if(!this.flagFetchPoll){
            setTimeout(() => {
              this.fetchPoll()
            }, 300);
          }
        }

      }
    }

  }

  async choosePoll(){
    let pollInfo = this.state.pollInfo
    let currentMsg = {...this.state.currentMsg}
    let poll_id = pollInfo.poll_id
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
    fetch(global.rxu.get(global.rxu.config, 'api_get_poll')+poll_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
      if(json && json.status !== 0){
        let pollInfoTmp = json
        pollInfoTmp.sender_uin = currentMsg.sender_uin
        pollInfoTmp.currentMsg = currentMsg
        // if(pollInfoTmp.status === 1){
          this.props.choosePoll(pollInfoTmp)
        // }
        this.setState({pollInfo:pollInfoTmp})
      }else{
        alert(translate('Poll has been deleted'))
      }

    }).catch(er => console.log(er))

  }
  getPollBtnTxt(pollInfo){
    let result = translate('Vote')
    if(pollInfo.status === 2){
      result = translate('View poll')
    }else{
      let user
      let answers = pollInfo.answers
      if(pollInfo && pollInfo.answers){
        for (let i = 0; i < answers.length; i++) {
          if(!user){
            user = answers[i].users.find(o => o.Id === this.userid);
          }
  
        }
        if(user){
          result = translate('Change vote')
        }else{
          result = translate('Vote')
        }
      }


    }

    return result
  }


  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  rxgroup: state.rxgroup,
  rxChangePolls:state.rxChangePolls,
  netaauth: state.netaauth,  
})

const mapDispatchToProps = {

}

const RxPollItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxPollItem_)

export default RxPollItem